import { useCallback, useState } from 'react';
import { useSnackbar } from 'notistack';
import useExport from './useTaskExport';

export default function useLogic() {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [selectedIds, setSelectedIds] = useState([]);
    const [isExporting, setExporting] = useState(false);
    const [isUpdatingSelection, setUpdatingSelection] = useState(false);
    const [searchId, setSearchId] = useState('');

    const selectAll = useCallback(async () => {
        setUpdatingSelection(true);
        setUpdatingSelection(false);
    }, [searchId]);

    const exportTasks = useExport();

    const onExportClick = async (selectedIds) => {
        let indicatorId;

        if (!selectedIds || selectedIds.length === 0) {
            return enqueueSnackbar('Please Select Atleast One Asset To Export', { variant: 'error' });
        }

        indicatorId = enqueueSnackbar(`Exporting ${selectedIds.length} Tasks`, {
            variant: 'info',
            persist: true,
        });

        setExporting(true);

        try { await exportTasks(selectedIds); }
        finally {
            setExporting(false);
            closeSnackbar(indicatorId);
        }
    };

    return {
        isLoading: isUpdatingSelection,
        selectedIds, setSelectedIds,
        isExporting, onExportClick,
        selectAll,
        searchId, setSearchId
    };
}